export const ROLES = {
  PLATFORM_ADMIN: 'platform_admin',
  COMMUNITY_ADMIN: 'community_admin',
  SESSION_MODERATOR: 'session_moderator',
  USER: 'user',
};

export const SESSION_ROLES = {
  HOST: 'host',
  SPEAKER: 'speaker',
  MODERATOR: 'moderator',
  PARTICIPANT: 'participant',
};

export const canManagePlatform = (user) => {
  return user?.role === ROLES.PLATFORM_ADMIN;
};

export const canManageCommunity = (user, communityId, community = null) => {
  if (canManagePlatform(user)) return true;
  
  const isOwner = community && user && (
    String(community.owner_id) === String(user.id) || 
    (community.owner && String(community.owner.id) === String(user.id))
  );

  if (isOwner) return true;

  if (user?.role === ROLES.COMMUNITY_ADMIN) {
    if (!communityId) return true;
    if (!Array.isArray(user.managedCommunities) || user.managedCommunities.length === 0) return true;
    return user.managedCommunities.includes(communityId);
  }
  return false;
};

export const canModerateSession = (user, sessionId, communityId, session = null) => {
  if (canManagePlatform(user)) return true;
  if (canManageCommunity(user, communityId)) return true;
  
  // If user is the owner of the session/room
  if (user && session && (
    String(session.owner_id) === String(user.id) || 
    String(session.host_id) === String(user.id) || 
    String(session.creator_id) === String(user.id) || 
    String(session.user_id) === String(user.id) ||
    String(session.author_id) === String(user.id)
  )) {
    return true;
  }

  if (user && session) {
    const sessionModerators = [
      ...(Array.isArray(session.moderators) ? session.moderators : []),
      ...(Array.isArray(session.settings?.moderators) ? session.settings.moderators : []),
      ...(Array.isArray(session.community?.moderators) ? session.community.moderators : []),
    ].flat();

    if (sessionModerators.some((candidate) => String(candidate?.id || candidate) === String(user.id))) {
      return true;
    }
  }

  if (user?.role === ROLES.SESSION_MODERATOR) {
    if (!sessionId) return true;
    if (!Array.isArray(user.managedSessions) || user.managedSessions.length === 0) return true;
    return user.managedSessions.includes(sessionId);
  }
  return false;
};

export const hasSessionRole = (userSessionRole, requiredRole) => {
  const roleWeights = {
    [SESSION_ROLES.HOST]: 100,
    [SESSION_ROLES.MODERATOR]: 50,
    [SESSION_ROLES.SPEAKER]: 30,
    [SESSION_ROLES.PARTICIPANT]: 10,
  };

  return (roleWeights[userSessionRole] || 0) >= (roleWeights[requiredRole] || 0);
};
